var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10140_10267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0455 7C17.0424 7 15.129 7.71152 13.7097 9.13076C14.3669 9.82838 14.9596 10.5867 15.4803 11.3967C16.365 10.4388 17.6288 9.84228 19.0417 9.84228C21.616 9.84228 23.7026 11.9212 23.7026 14.4994C23.7026 16.5088 22.4287 18.2212 20.6454 18.8734C20.145 19.0566 19.6053 19.1565 19.0417 19.1565C17.5921 19.1565 16.2967 18.4942 15.4424 17.4567C15.2162 17.1887 15.0152 16.893 14.8471 16.5733C14.4124 15.7467 14.1394 14.8444 13.9322 13.9382C13.7122 12.9778 13.3622 12.0615 12.815 11.2388C12.6532 10.9949 12.4763 10.7585 12.2829 10.5386C11.5183 9.65903 10.4554 9.04229 9.20682 8.75668C6.21415 8.0717 3.16587 9.83217 2.26478 12.7629C1.78833 14.3123 1.95894 15.9439 2.74376 17.3581C3.52858 18.7723 4.82271 19.7795 6.38729 20.194C7.23529 20.419 8.13512 20.4506 8.99197 20.2888C9.50381 20.1915 10.2659 19.9817 11.0103 19.5432C10.4757 18.7622 10.0081 17.9318 9.62134 17.0573C9.42419 17.1799 9.19165 17.2873 8.93889 17.3694C8.61662 17.4845 8.26908 17.5476 7.90637 17.5476C6.21667 17.5476 4.84545 16.1827 4.84545 14.4981C4.84545 13.8018 5.08937 13.1168 5.53043 12.5771C5.8388 12.1993 6.23942 11.8947 6.68554 11.6988C7.30354 11.4296 8.00874 11.374 8.66086 11.5433C9.54678 11.767 10.2785 12.3762 10.6665 13.18C10.9193 13.6476 11.0697 14.1607 11.191 14.6763C11.311 15.1856 11.4412 15.6886 11.608 16.1853C11.8052 16.7742 12.0428 17.3492 12.3322 17.8977C13.663 20.4278 16.2373 21.9987 19.0493 21.9987C23.1844 21.9987 26.5486 18.6345 26.5486 14.4994C26.5486 10.3642 23.1806 7 19.0455 7Z",
    fill: "url(#paint0_linear_10140_10267)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10140_10267",
    x1: 1.99938,
    y1: 14.4994,
    x2: 26.5448,
    y2: 14.4994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10140_10267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5455,
    height: 15,
    fill: "white",
    transform: "translate(2 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBe);
export default __webpack_public_path__ + "static/media/be.ff414ee9f6a0ed47508440e9f3af3787.svg";
export { ForwardRef as ReactComponent };